var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon7BlogCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.33V16a3 3 0 0 0 3 3h9a3 3 0 0 0 3-2.92l1.75 1.4A2 2 0 0 0 22 15.92V8.08a2 2 0 0 0-3.25-1.56L17 7.92A3 3 0 0 0 14 5H5a3 3 0 0 0-3 3v2.33zm15 .15v3.04l3 2.4V8.08l-3 2.4zM4 16V8a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0yIDEwLjMzVjE2YTMgMyAwIDAgMCAzIDNoOWEzIDMgMCAwIDAgMy0yLjkybDEuNzUgMS40QTIgMiAwIDAgMCAyMiAxNS45MlY4LjA4YTIgMiAwIDAgMC0zLjI1LTEuNTZMMTcgNy45MkEzIDMgMCAwIDAgMTQgNUg1YTMgMyAwIDAgMC0zIDN2Mi4zM3ptMTUgLjE1djMuMDRsMyAyLjRWOC4wOGwtMyAyLjR6TTQgMTZWOGExIDEgMCAwIDEgMS0xaDlhMSAxIDAgMCAxIDEgMXY4YTEgMSAwIDAgMS0xIDFINWExIDEgMCAwIDEtMS0xeiIgZmlsbC1ydWxlPSJldmVub2RkIi8+DQo8L3N2Zz4NCg==";
export { SvgIcon7BlogCamera as ReactComponent };